import { render, staticRenderFns } from "./UserPortalVerification.vue?vue&type=template&id=9d60e372&"
import script from "./UserPortalVerification.vue?vue&type=script&lang=js&"
export * from "./UserPortalVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports